export default {
  persistentErrors: [],
  errors: []
};
